import {
  base_colorRaisedSurface,
  base_colorSurfaceMuted,
  base_colorSurfaceMutedHover,
  input_borderDefault,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { button_transitionSpeed } from 'ext-ui/style/transitionSpeeds'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.ReportingAgentChatEmptyState {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${spacing(8)} 0;
    text-align: center;

    & .agent-avatar {
      width: ${spacing(12)};
      height: ${spacing(12)};
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: ${spacing(4)};

      & .reporting-agent-avatar {
        transform: scale(2);
      }
    }

    & .empty-state-title {
      ${font_lg};
      font-family: ${font_family_weight_medium};
      color: ${text_colorTextPrimary};
      margin-bottom: ${spacing(2)};
    }

    & .empty-state-subtitle {
      ${font_md};
      color: ${text_colorTextSecondary};
      margin-bottom: ${spacing(12)};
      max-width: ${spacing(100)};
    }

    & .prompts-list {
      display: flex;
      flex-direction: column;
      gap: ${spacing(2)};
      width: 100%;
      max-width: ${spacing(125)};

      & .prompt-button {
        display: flex;
        align-items: center;
        gap: ${spacing(3)};
        width: 100%;
        padding: ${spacing(3)};
        border-radius: ${cornerRadius};
        border: 1px solid ${input_borderDefault};
        background-color: ${base_colorRaisedSurface};
        font-family: ${font_family_weight_regular};
        ${font_md};
        color: ${text_colorTextPrimary};
        text-align: start;
        cursor: pointer;
        transition: background-color ${button_transitionSpeed} ease-out;

        &:hover {
          background-color: ${base_colorSurfaceMuted};
        }

        &:active {
          background-color: ${base_colorSurfaceMutedHover};
        }

        &:focus-visible {
          outline: 2px solid ${text_colorTextPrimary};
          outline-offset: ${spacing(1)};
        }

        & .prompt-button-icon {
          flex-shrink: 0;
          display: flex;
        }
      }
    }
  }
`
